/* Shopify contact form, enhanced before Shopify wires CAPTCHA on interaction.
   Shopify wraps this form's submit method and calls it after obtaining its token.
   If CAPTCHA has already bound, retain the native submission and return path. */
(() => {
  document.querySelectorAll('.product-callback').forEach((widget) => {
    if (widget.dataset.ready) return;
    widget.dataset.ready = 'true';
    const form = widget.querySelector('form');
    const button = form.querySelector('button');
    const phone = form.querySelector('input[type="tel"]');
    const error = widget.querySelector('[role="alert"]');
    const success = widget.querySelector('[role="status"]');
    const label = button.textContent;
    let pending = false;
    let sending = false;
    let timer;
    const fail = (message) => {
      clearTimeout(timer);
      pending = sending = false;
      button.disabled = false;
      button.textContent = label;
      form.removeAttribute('aria-busy');
      error.textContent = message;
      error.hidden = false;
    };
    const done = () => {
      clearTimeout(timer);
      // Collapse the submitted fields so the card fits its confirmation.
      form.hidden = true;
      form.inert = true;
      form.removeAttribute('aria-busy');
      success.hidden = false;
      success.focus({ preventScroll: true });
      phone.value = '';
    };
    if (!form.dataset.hcaptchaBound && !form.dataset.recaptchaBound) {
      form.submit = async () => {
        if (!pending || sending) return;
        sending = true;
        clearTimeout(timer);
        try {
          const response = await fetch(form.action, { method: 'POST', body: new FormData(form), signal: AbortSignal.timeout(30000) });
          const url = new URL(response.url);
          response.body?.cancel();
          if (url.pathname === '/challenge') {
            // Continue Shopify's existing challenge, without repeating the POST.
            location.assign(url.href);
          } else if (response.ok && response.redirected && url.searchParams.get('callback_sent') === '1' && url.pathname === location.pathname) {
            done();
          } else {
            fail('Prošnje ni bilo mogoče poslati. Poskusite znova ali pišite na info@guamkozmetika.si.');
          }
        } catch (_) {
          fail('Oddaje ni bilo mogoče potrditi. Pišite nam na info@guamkozmetika.si.');
        }
      };
    }
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (pending || form.querySelector('[data-callback-honeypot]').value || !form.reportValidity()) return;
      error.hidden = true;
      pending = true;
      button.disabled = true;
      button.textContent = 'Pošiljam …';
      form.setAttribute('aria-busy', 'true');
      timer = setTimeout(() => {
        if (!sending) fail('Preverjanje ni zaključeno. Poskusite znova ali pišite na info@guamkozmetika.si.');
      }, 60000);
      if (window.Shopify?.captcha?.protect) {
        window.Shopify.captcha.protect(form, () => { if (pending) form.submit(); });
      } else {
        form.submit();
      }
    }, true);
    // Native fallback / challenge return. Remove flags so a reload resets the widget.
    const url = new URL(location.href);
    if (url.searchParams.get('callback_sent') === '1' && url.searchParams.get('contact_posted') === 'true') {
      done();
      url.searchParams.delete('callback_sent');
      url.searchParams.delete('contact_posted');
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    }
  });
})();
